import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loader from "../Loader/Loader";
import { LOCALES, getTranslations } from "../../i18n/i18n";
import { UserPreferencesContext } from "../../contexts/UserPreferencesContext";

const AuthRoutes = ({
	children,
	requireAuth = false,
	theme = "light",
	locale = LOCALES.ENGLISH,
}) => {
	const { authInitialized, currentUser, userRole } = useContext(
		UserPreferencesContext
	);
	const location = useLocation();
	const currentPath = location.pathname;

	if (!authInitialized) {
		const { translate } = getTranslations(locale);
		return <Loader theme={theme} translate={translate} />;
	}

	// Redirect to /auth if authentication is required and no user is logged in
	if (requireAuth && !currentUser) return <Navigate to="/auth" />;

	// Redirect unverified users to /settings unless already on that page
	if (
		currentUser &&
		!currentUser.emailVerified &&
		currentPath !== "/settings"
	) {
		return <Navigate to="/settings" replace />;
	}

	// Admin access control: wait for userRole to be defined
	if (currentUser && currentPath === "/admin") {
		// Show loader while role is undefined
		if (typeof userRole === "undefined") {
			const { translate } = getTranslations(locale);
			return <Loader theme={theme} translate={translate} />;
		}

		// Redirect to /home if the user is not admin
		if (userRole !== "admin") {
			return <Navigate to="/home" />;
		}
	}

	return children;
};

export default AuthRoutes;
